import { Link } from 'ui/components/primitives';
import { theme, styled } from 'ui/theme';

export const ListComponentsTalkTo = {
  Ul: styled.ul`
    display: flex;
    flex-direction: column;
    padding: 0;
    margin: 0;
  `,

  Li: styled.li`
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.build.mediumLight1};
    padding: ${theme.space[2]} 0;
    list-style: none;
  `,
  Link: styled(Link)`
    font-family: ${theme.fonts.primary};
    font-size: ${theme.fontSizes.sm};
    color: ${theme.colors.build.mediumLight1};
    display: flex;
    align-items: center;
    gap: ${theme.space[2]};
  `,
  Div: styled.div`
    display: flex;
    justify-content: center;
    gap: ${theme.space[7]};
  `,
};

export const DividerSpanTalkTo = {
  Component: styled.hr`
    border: none;
    border-top: 1px solid ${theme.colors.build.mediumLight2};
    width: ${theme.space[24]};
  `,
};
